<template>
  <v-card>
    <v-card-title>
      <span>{{ title }}</span>
      <v-spacer></v-spacer>
      <v-btn
        icon
        @click="close()"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-row v-if="!realTime">
        <v-col>
          <v-card>
            <v-card-text class="mb-2">
              <v-row>
                <v-col
                  cols="12"
                  md="5"
                >
                  <koiote-date-picker
                    dateLabel="Fecha Inicio"
                    hourLabel="Hora Inicio"
                    :type="1"
                  ></koiote-date-picker>
                </v-col>
                <v-col
                  cols="12"
                  md="5"
                >
                  <koiote-date-picker
                    dateLabel="Fecha Fin"
                    hourLabel="Hora Fin"
                    :type="2"
                  ></koiote-date-picker>
                </v-col>
                <v-col
                  cols="12"
                  md="2"
                  class="d-flex align-self-center"
                >
                  <v-btn
                    block
                    @click="addDataToVariable(1)"
                  >
                    Buscar
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <!-- Sidebar (10%) -->
        <!-- Contenido de la barra lateral -->
        <v-col
          v-if="!realTime"
          cols="3"
          class="sidebar"
        >
          <v-card class="scrollable-card">
            <v-card-title>Seleccionar variables</v-card-title>
            <v-card-text>
              <v-list>
                <v-list-item-group
                  v-model="selected_variables"
                  multiple
                  color="blue"
                  @change="addDataToVariable(2)"
                >
                  <v-list-item
                    v-for="(item, index) in available_variables"
                    :key="index"
                    :value="item"
                  >
                    <v-list-item-title class="body-2">{{ item.id }} - {{ item.description }}</v-list-item-title>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- Main Content (90%) -->
        <v-col :cols="realTime ? 12 : 9">
          <!-- Contenido principal -->
          <v-card class="scrollable-card">
            <v-card-text>
              <template v-if="!selected_variables.length">
                <div>Seleccione al menos una variable para visualizar la gráfica.</div>
              </template>
              <template v-else-if="!loading && !computed_chart_data?.datasets?.length">
                <div>No se han encontrado datos para las fechas seleccionadas.</div>
              </template>
              <template v-else>
                <!-- Gráfica-->
                <v-row v-if="loading">
                  <v-col>
                    <v-progress-linear
                      indeterminate
                      color="primary"
                    ></v-progress-linear>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <line-chart
                      :chart-data="computed_chart_data"
                      @render-complete="onRenderComplete"
                    ></line-chart>
                  </v-col>
                </v-row>
                <!-- Tabla  con los datos -->
                <template v-if="!realTime && table_data?.length">
                  <v-row>
                    <v-col cols="9">
                      <h2>Detalles</h2>
                    </v-col>
                    <v-col cols="3">
                      <v-btn
                        dark
                        color="#da4726"
                        @click="downloadData()"
                      >
                        <v-icon class="mr-1">mdi-file-download</v-icon>
                        DESCARGAR
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-data-table
                        :headers="table_header"
                        :items="table_data"
                      >
                      </v-data-table>
                    </v-col>
                  </v-row>
                </template>
              </template>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import moment from "moment-timezone";
import * as XLSX from "xlsx";

import { mapGetters, mapActions } from "vuex";

import LineChart from "@/components/utils/LineChart.vue";
import KoioteDatePicker from "@/components/utils/KoioteDatePicker.vue";

export default {
  components: {
    LineChart,
    KoioteDatePicker,
  },

  props: {
    title: String,
    realTime: Boolean,
    address: String,
  },

  data() {
    return {
      available_variables: [],
      selected_variables: [],

      chart_data: {},
      table_data: [],

      loading: true,
    };
  },

  computed: {
    connection() {
      return this.actualPage()?.global_item_list?.find((gi) => gi.settings.component_type.includes("connection"))
        ?.customized;
    },

    computed_chart_data() {
      return this.realTime
        ? {
            datasets: [
              {
                data: this.getHistoryValues().map((d) => d.formatted_value),
                label: this.selected_variables[0].description,
                backgroundColor: "#2b90c2",
                segment: { borderColor: "#2b90c2" },
                pointRadius: 0,
              },
            ],
            labels: this.getHistoryValues().reduce(function (timestamps, chartData) {
              if (!timestamps.includes(chartData.formatted_timestamp)) timestamps.push(chartData.formatted_timestamp);
              return timestamps;
            }, []),
          }
        : this.chart_data;
    },

    table_header() {
      const headers = this.selected_variables?.map((v) => ({ text: `${v?.description}`, value: `${v?.id}` }));
      headers.unshift({ text: "Fecha", value: "read_at" });
      return headers;
    },
  },

  methods: {
    ...mapGetters(["actualPage"]),
    ...mapGetters("utils", ["getInitDateFilter", "getEndDateFilter"]),
    ...mapGetters("nodered", ["getHistoryValues"]),
    ...mapActions(["getData", "setSelectedPage", "loadPages"]),

    async addDataToVariable(origin) {
      this.loading = true;
      if (origin === 1) {
        this.chart_data = {};
        this.table_data = [];
      }

      const params = {
        variables: JSON.stringify(this.selected_variables?.map((v) => v.id)),
        initDate: this.getInitDateFilter(),
        endDate: this.getEndDateFilter(),
      };

      const { table_data, ...chartData } = await this.getData({
        path: `variables/history/chart`,
        params: params,
      });

      chartData.labels = chartData?.labels?.map((date) =>
        moment.tz(date, moment.tz.guess()).format("DD/MM/YYYY HH:mm:ss")
      );

      this.chart_data = chartData;

      this.table_data = table_data?.map((td) => ({
        ...td,
        read_at: moment.tz(td.read_at, moment.tz.guess()).format("DD/MM/YYYY HH:mm:ss"),
      }));
    },

    downloadData() {
      if (this.table_header.length > 1) {
        const ws = XLSX.utils.aoa_to_sheet([this.table_header?.map((header) => header.text)]);
        this.table_data.forEach((item) => {
          const row = this.table_header?.map((header) => (item[header.value] !== null ? item[header.value] : ""));
          XLSX.utils.sheet_add_aoa(ws, [row], { origin: -1 });
        });
        const wb = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(wb, ws, "Data");
        const file_name = "datos_variables_seleccionadas";
        XLSX.writeFile(wb, file_name + ".xlsx");
      }
    },

    close() {
      this.$emit("close");
    },

    onRenderComplete() {
      this.loading = false;
    },
  },

  async created() {
    if (this.$route.path.includes("/history")) {
      await this.loadPages();
      this.setSelectedPage(this.$route.params.page_index);
    }

    const { variables } = await this.getData({
      path: "variables/history",
      params: { topicRead: this.connection?.topic_read || "PLC0R" },
    });
    this.available_variables = variables;

    if (this.address) {
      this.selected_variables = [this.available_variables.find((v) => v.formatted_address == this.address)];
    }
  },
};
</script>

<style>
.scrollable-card {
  max-height: 600px;
  overflow-y: auto;
}
</style>
